import React, { useEffect, useState, useRef } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Home/Index";
import ApiCall from "../common/ApiCall";
import { setLoading, setLogout } from "../redux/user/user.action";
import { useDispatch, useSelector } from "react-redux";
import { setIPLocation, setSearchHistory } from "../redux/global/global.action";
import { useLocation, useNavigate } from 'react-router-dom';
import { generateSlug, getSlugByLang, getSlugNameByLang } from "../common/Helper";

export default function HomeController() {
    const [productList, setProductList] = useState([]);
    const [tourStyle, setTourStyle] = useState([]);
    const [topAttractionList, setTopAttractionList] = useState([]);
    const [nextLocations, setNextLocations] = useState([]);
    const [nextTheme, setNextTheme] = useState({});
    const [attractionNearNextPageUrl, setAttractionNearNextPageUrl] = useState('');
    const [tourStyleNextPageUrl, setTourStyleNextPageUrl] = useState('');
    const [nextLocationNextPageUrl, setNextLocationNextPageUrl] = useState('');
    const [topAttractionNextPageUrl, setTopAttractionNextPageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [isAttractionNearLoading, setIsAttractionNearLoading] = useState(false);
    const [isTourStyleLoading, setIsTourStyleLoading] = useState(false);
    const [isTopAttrLoading, setIsTopAttrLoading] = useState(false);
    const [isNextVacationLoading, setIsNextVacationLoading] = useState(false);
    const [isDefLoading, setIsDefLoading] = useState(false);
    const [destinationSuggetions, setDestinationSuggetions] = useState([]);
    const [activitiesSuggetion, setActivitiesSuggetion] = useState([]);
    const [productsSuggetion, setProductsSuggetion] = useState([]);
    const [blogsSuggetion, setBlogsSuggetion] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const dropdownRef = useRef(null);
    const searchKeyRef = useRef(null);
    const location = useLocation()
    const navigate = useNavigate()
    const [suggetionHistory, setSuggetionHistory] = useState([]);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const user = useSelector((state) => state.user);
    const global = useSelector((state) => state.global);
    const dispatch = useDispatch();
    const locationDetail = global?.locationDetail
    const locationStoreTime = global.locationStoreTime
    const searchHistory = global?.searchHistory
    const typingTimer = useRef(null);

    const getHomePageList = async (type = 'ALL', page = null) => {
        dispatch(setLoading(false))
        let data = {}
        data.type = type;
        data.page = page;
        if (user.token) {
            data.user_id = user.userDetails.id
        } else {
            data.visitedList = global.visitedList
        }

        if (type == 'ALL') {
            setIsLoading(true)
        }
        // if (type == 'products') {
        //     setIsAttractionNearLoading(true)
        // }

        if (type == 'tourStyle') {
            // data.tourStyle = JSON.stringify(tourStyle.map((item) => item.name))
            data.tourStyle = JSON.stringify(tourStyle.map((item) => (item?.activity_theme?.name ? item?.activity_theme?.name : item?.name)))
            setIsTourStyleLoading(true)
        }

        if (type == 'topAttraction') {
            setIsTopAttrLoading(true)
        }

        if (type == 'nextVacation') {
            data.nextVacation = JSON.stringify(nextLocations.map((item) => item.related_id))
            setIsNextVacationLoading(true)
        }

        const getList = await ApiCall('post', 'home-list', data)

        setIsLoading(false)
        setIsAttractionNearLoading(false)
        setIsTourStyleLoading(false)
        setIsTopAttrLoading(false)
        setIsNextVacationLoading(false)

        if (getList) {

            if (getList?.data?.success) {
                if (type == 'ALL') {
                    // setProductList(getList.data.data.products)
                    setTourStyle(getList.data.data.tourStyle)
                    setTopAttractionList(getList.data.data.topAttraction)
                    setNextLocations(getList.data.data.locations)
                    // setNextTheme(getList.data.data.themesNext)
                    // setAttractionNearNextPageUrl(getList.data.data.attraction_near_next_page_url)
                    setTourStyleNextPageUrl(getList.data.data.themes_next_page_url)
                    setTopAttractionNextPageUrl(getList.data.data.top_attraction_next_page_url)
                    setNextLocationNextPageUrl(getList.data.data.next_vacation_next_page_url)

                }
                // if (type == 'products') {
                //     setProductList(prevProducts => [...prevProducts, ...getList.data.data.products]);
                //     setAttractionNearNextPageUrl(getList.data.data.attraction_near_next_page_url)
                // }


                if (type == 'nextVacation') {
                    setNextLocations(prevProducts => [...prevProducts, ...getList.data.data.locations]);
                    setNextLocationNextPageUrl(getList.data.data.next_vacation_next_page_url)
                }

                if (type == 'tourStyle') {
                    setTourStyle(prevProducts => [...prevProducts, ...getList.data.data.tourStyle]);
                    setTourStyleNextPageUrl(getList.data.data.themes_next_page_url)
                }

                if (type == 'topAttraction') {
                    setTopAttractionList(prevProducts => [...prevProducts, ...getList.data.data.topAttraction]);
                    setTopAttractionNextPageUrl(getList.data.data.top_attraction_next_page_url)
                }
            }
        }
    }

    const getNearestTourList = async (type = 'ALL', page = null, loc = null) => {

        let locDetail = loc ? JSON.parse(loc) : {};
        let data = {}
        data.type = type;
        data.page = page;
        // data.latitude = locDetail?.lat ? locDetail.lat : 41.530918
        // data.longitude = locDetail?.lon ? locDetail.lon : -8.780565
        data.latitude = locDetail?.lat
        data.longitude = locDetail?.lon
        data.loaded_ids = JSON.stringify(productList.map((item) => item?.id))

        // data.loaded_ids = JSON.stringify(productList.map((item) => item.id))
        // data.loaded_supplier_ids = JSON.stringify(productList.map((item) => item.supplier_id))

        if (user.token) {
            data.user_id = user.userDetails.id
        }
        if (type == 'ALL') {
            setIsDefLoading(true)
        }
        if (type == 'products') {
            setIsAttractionNearLoading(true)
        }

        const getList = await ApiCall('post', 'nearest-tours', data)
        setIsAttractionNearLoading(false)
        setIsDefLoading(false)


        if (getList) {

            if (getList?.data?.success) {
                if (type == 'ALL') {
                    setProductList(getList.data.data.products)
                    setAttractionNearNextPageUrl(getList.data.data.attraction_near_next_page_url)
                }
                if (type == 'products') {
                    setProductList(prevProducts => [...prevProducts, ...getList.data.data.products]);
                    setAttractionNearNextPageUrl(getList.data.data.attraction_near_next_page_url)
                }
                if (getList.data.data.locationDetails) {
                    dispatch(setIPLocation(JSON.stringify(getList.data.data.locationDetails)))
                }

            }
        }
    }


    const onClickLoadMore = async (type, page) => {
        if (type == 'products') {
            await getNearestTourList(type, page, locationDetail)
        } else {
            await getHomePageList(type, page)
        }
    }

    const getIpLocationData = async () => {
        const fetchLocationDetail = await ApiCall('get', 'http://ip-api.com/json/', null, null, true)
        if (fetchLocationDetail && fetchLocationDetail?.data) {
            dispatch(setIPLocation(JSON.stringify(fetchLocationDetail.data)))
            return fetchLocationDetail.data;
        }
    }

    // useEffect(() => {
    //     const currentTime = Date.now();
    //     const twoDaysInMillis = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
    //     (async () => {
    //         await getHomePageList()
    //         if (productList.length == 0) {

    //             if (!locationDetail || (currentTime - locationStoreTime) > twoDaysInMillis) {

    //                 await getNearestTourList()

    //             } else {
    //                 await getNearestTourList(locationDetail)
    //             }
    //         }
    //     })();
    // }, [user.token, locationDetail, locationStoreTime, productList]);

    useEffect(() => {

        (async () => {
            await getHomePageList()
            // await getNearestTourList(locationStoreTime)
        })();
    }, [user.token]);

    useEffect(() => {
        const fetchNearestTours = async () => {
            const currentTime = new Date().getTime();
            const storedTime = locationStoreTime ? new Date(locationStoreTime).getTime() : null;
            const twoDaysInMillis = 2 * 24 * 60 * 60 * 1000;

            // Determine if the stored location is valid or old
            const isOld = storedTime ? currentTime - storedTime > twoDaysInMillis : true;

            // Avoid making repeated API calls
            if (!isOld && global?.locationDetail) {
                // console.log('not old');

                // If location is valid, pass it to the API
                await getNearestTourList('ALL', null, global?.locationDetail);
            } else if (isOld) {
                // If location is old, call the API without lat/lng
                // console.log('o,ld');
                await getNearestTourList('ALL');
            }
        };

        fetchNearestTours();
    }, [user.token, global?.locationDetail]);


    const getSearchSuggetions = async (search) => {
        setIsSearchLoading(true)
        var lang = getSlugByLang(user?.language);
        let data = {}
        data.search = search
        data.lang = lang

        const recordList = await ApiCall('post', 'search-suggetions', data)
        setIsSearchLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {
                setDestinationSuggetions(recordList.data.data.destinations)
                setActivitiesSuggetion(recordList.data.data.activities)
                setProductsSuggetion(recordList.data.data.products)
                setBlogsSuggetion(recordList.data.data.blogs)
            }
        }
    };



    const handleKeyUp = async (e) => {

        const value = e.target.value;
        clearTimeout(typingTimer.current); // Clear previous timer

        if (value.trim().length === 0) {
            setDestinationSuggetions([])
            setActivitiesSuggetion([])
            setProductsSuggetion([])
            setBlogsSuggetion([])
            setIsSearchLoading(false);
        }
        setIsSearchLoading(false);
        if (value.length >= 3) {
            setIsSearchLoading(true);
            typingTimer.current = setTimeout(() => {
                getSearchSuggetions(value);
            }, 500); // Call function only after 0.5s of no typing
        }
        // setSearchValue(value);
    };

    const onClickReset = () => {
        setSearchValue("");
        setDestinationSuggetions([])
        setActivitiesSuggetion([])
        setProductsSuggetion([])
        setIsSearchFocused(false)
    }

    const onClickDestination = (name, sublabel, destination) => {
        // let slug = generateSlug(destination)
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?location_name=' + destination
        let dta = {
            label: name,
            // url: '/search?location_name=' + destination,
            url: url,
            sublabel: sublabel
        }
        updateSearchHistory(dta)
        navigate(url)
    }

    const onClickBlog = (name, slug) => {

        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/blog/article/' + slug

        let dta = {
            label: name,
            // url: '/blog/article/' + slug,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)
        // navigate('/blog/article/' + slug)
        navigate(url)
    }

    const onClickActivity = (id, name, activity) => {
        // let slug = generateSlug(activity)
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?categories=' + id
        let dta = {
            label: name,
            // url: '/search?categories=' + id,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)
        navigate(url)
    }

    const onClickProduct = (name, sublabel, slug) => {
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/tour/' + slug
        let dta = {
            label: name,
            // url: `/tour/${slug}`,
            url: url,
            sublabel: sublabel
        }
        updateSearchHistory(dta)
        // navigate(`/tour/${slug}`)
        navigate(url)


    }

    useEffect(() => {
        // Check if the script is already loaded to avoid loading it multiple times

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup: Remove the script when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, [productList, topAttractionList]);

    const updateSearchHistory = (rec) => {
        let sh = searchHistory ? searchHistory : []
        let hist = [...sh]


        if (!hist.some(item => item.url === rec.url)) {

            if (hist.length >= 5) {
                hist.pop();
            }
            hist.unshift(rec);
            dispatch(setSearchHistory(hist));
        }

    }

    useEffect(() => {
        setSuggetionHistory(searchHistory)
    }, [searchHistory]);

    // useEffect(() => {
    //     dispatch(setSearchHistory([]));
    // }, []);

    const handleClickOutside = (event) => {

        // if (dropdownRef?.current && !dropdownRef?.current.contains(event?.target) &&
        //     searchKeyRef.current && !searchKeyRef.current.contains(event.target)) {
        //     setDestinationSuggetions([])
        //     setActivitiesSuggetion([])
        //     setProductsSuggetion([])
        //     setIsSearchFocused(false)
        // }

        setTimeout(() => {
            if (
                dropdownRef?.current && !dropdownRef.current.contains(event.target) &&
                searchKeyRef?.current && !searchKeyRef.current.contains(event.target)
            ) {
                setDestinationSuggetions([]);
                setActivitiesSuggetion([]);
                setProductsSuggetion([]);
                setIsSearchFocused(false);
            }
        }, 100);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const adjustScrollIfNeeded = () => {
        if (!searchKeyRef.current) return;

        const rect = searchKeyRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const extraPadding = 20; // Adjust this value to scroll up a bit more


        // If the bottom of the div is outside the viewport, adjust scrolling
        // if (rect.bottom > windowHeight) {
        //     searchKeyRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        // }
        if (rect.bottom > windowHeight) {
            window.scrollBy({
                top: rect.bottom - windowHeight + extraPadding,
                behavior: "smooth"
            });
        }
    };

    useEffect(() => {
        if (isSearchFocused) {
            adjustScrollIfNeeded();
        }
    }, [isSearchFocused]);

    // useEffect(() => {
    //     if (location.pathname !== '/' && location.pathname !== '/home') {
    //         // navigate('/', { replace: true });
    //         window.history.replaceState(null, "", '/');
    //     }


    // }, [location.pathname]);

    // const slugLang = getSlugByLang(user?.language) || 'en'; // fallback to 'en'

    // useEffect(() => {
    //     const isHomePath = location.pathname === `/${slugLang}` || location.pathname === `/${slugLang}/home`;

    //     if (!isHomePath) {

    //         navigate(`/${slugLang}`, { replace: true });
    //     }
    // }, [location.pathname, navigate, slugLang]);



    // console.log('str',process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    // console.log('pp',process.env.REACT_APP_PAYPAL_CLIENT_ID);


    return (

        <>

            <PageTitle title={'Find The Best Vacation Experiences'} />
            <Index
                productList={productList}
                isLoading={isLoading}
                tourStyle={tourStyle}
                topAttractionList={topAttractionList}
                nextTheme={nextTheme}
                nextLocations={nextLocations}
                attractionNearNextPageUrl={attractionNearNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isAttractionNearLoading}

                isTourStyleLoading={isTourStyleLoading}
                tourStyleNextPageUrl={tourStyleNextPageUrl}

                isTopAttrLoading={isTopAttrLoading}
                topAttractionNextPageUrl={topAttractionNextPageUrl}

                isDefLoading={isDefLoading}

                isNextVacationLoading={isNextVacationLoading}
                nextLocationNextPageUrl={nextLocationNextPageUrl}

                handleKeyUp={handleKeyUp}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onClickReset={onClickReset}

                isSearchLoading={isSearchLoading}
                blogsSuggetion={blogsSuggetion}
                productsSuggetion={productsSuggetion}
                activitiesSuggetion={activitiesSuggetion}
                destinationSuggetions={destinationSuggetions}
                onClickProduct={onClickProduct}
                onClickDestination={onClickDestination}
                onClickBlog={onClickBlog}

                onClickActivity={onClickActivity}
                dropdownRef={dropdownRef}

                suggetionHistory={suggetionHistory}
                setIsSearchFocused={setIsSearchFocused}
                isSearchFocused={isSearchFocused}
                searchKeyRef={searchKeyRef}
            />
        </>
    )

}